import { render, staticRenderFns } from "./NewSceneMod.vue?vue&type=template&id=fc213b38&scoped=true"
import script from "./NewSceneMod.vue?vue&type=script&lang=js"
export * from "./NewSceneMod.vue?vue&type=script&lang=js"
import style0 from "./NewSceneMod.vue?vue&type=style&index=0&id=fc213b38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc213b38",
  null
  
)

export default component.exports